import { useState } from 'react';

import { Alert, Box, Heading, Image, Modal, Tabs } from '@zillow/constellation-10';

import HouseholdeSummaryMWeb from '../../assets/applicationSample/mweb/HouseholdSummaryMWeb.png';
import ApplicantSummaryMWeb from '../../assets/applicationSample/mweb/ApplicantSummaryMWeb.png';
import BackgroundCheckMWeb from '../../assets/applicationSample/mweb/BackgroundCheckMWeb.png';
import CreditReportMWeb from '../../assets/applicationSample/mweb/CreditReportMWeb.png';
import HouseholdSummaryWeb from '../../assets/applicationSample/web/HouseholdSummaryWeb.png';
import ApplicantSummaryWeb from '../../assets/applicationSample/web/ApplicantSummaryWeb.png';
import BackgroundCheckWeb from '../../assets/applicationSample/web/BackgroundCheckWeb.png';
import CreditReportWeb from '../../assets/applicationSample/web/CreditReportWeb.png';

// `*.png` imports resolve to a URL string under webpack and to a `{ src }` object under Next.
function toImageSrc(image: string | { src: string }): string {
  return typeof image === 'string' ? image : image.src;
}

function SampleImage({ web, mweb, alt }: { web: string; mweb: string; alt: string }) {
  return (
    <>
      <Box css={{ display: { base: 'block', md: 'none' } }}>
        <Image src={mweb} alt={alt} css={{ width: '100%', height: 'auto' }} />
      </Box>
      <Box css={{ display: { base: 'none', md: 'block' } }}>
        <Image src={web} alt={alt} css={{ width: '100%', height: 'auto' }} />
      </Box>
    </>
  );
}

const PANEL_CSS = {
  overflowX: 'hidden',
  overflowY: 'auto',
  maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' },
} as const;

export const ApplicationSampleModal = ({ onClose }: { onClose: () => void }) => {
  const [selected, setSelected] = useState('household-tab');

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={6}>Zillow default application sample</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      css={{ minWidth: 0 }}
      body={
        <>
          <Alert role="status" tone="info" css={{ marginBottom: 'tight' }}>
            These documents are for viewing purposes only
          </Alert>
          <Tabs.Root appearance="default" selected={selected} onSelectedChange={setSelected}>
            <Tabs.List aria-label="sample-application-files" css={{ minWidth: 0, maxWidth: '100%', overflowX: 'auto' }}>
              <Tabs.Tab value="household-tab">Household Summary</Tabs.Tab>
              <Tabs.Tab value="summary-tab">Applicant Summary</Tabs.Tab>
              <Tabs.Tab value="credit-tab">Credit Report</Tabs.Tab>
              <Tabs.Tab value="background-tab">Background Check</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="household-tab" css={PANEL_CSS}>
              <SampleImage
                web={toImageSrc(HouseholdSummaryWeb)}
                mweb={toImageSrc(HouseholdeSummaryMWeb)}
                alt="Household Summary sample"
              />
            </Tabs.Panel>
            <Tabs.Panel value="summary-tab" css={PANEL_CSS}>
              <SampleImage
                web={toImageSrc(ApplicantSummaryWeb)}
                mweb={toImageSrc(ApplicantSummaryMWeb)}
                alt="Applicant Summary sample"
              />
            </Tabs.Panel>
            <Tabs.Panel value="credit-tab" css={PANEL_CSS}>
              <SampleImage
                web={toImageSrc(CreditReportWeb)}
                mweb={toImageSrc(CreditReportMWeb)}
                alt="Credit Report sample"
              />
            </Tabs.Panel>
            <Tabs.Panel value="background-tab" css={PANEL_CSS}>
              <SampleImage
                web={toImageSrc(BackgroundCheckWeb)}
                mweb={toImageSrc(BackgroundCheckMWeb)}
                alt="Background Check sample"
              />
            </Tabs.Panel>
          </Tabs.Root>
        </>
      }
    />
  );
};
